const PASSWORD_REGEX = new RegExp(/^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)[a-zA-Z\d]{8,100}$/)
const EMAIL_REGEX = new RegExp(
	/^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}.[A-Za-z0-9]{1,}$/
)
const KANA_REGEX = /^[\u30A0-\u30FF]+$/
const FLOAT_REGEX = /^([1-9]\d*|0)(\.\d+)?$/
const FLOAT_REGEX_WITH_NEGATIVE = /^[-]?([1-9]\d*|0)(\.\d+)?$/ // 符号小数点あり
const ZERO_OR_MORE_REGEX = /^([1-9]\d*|0)$/ // 0以上の整数
const INTEGER_REGEX_WITH_NEGATIVE = /^[-]?([1-9]\d*|0)$/ // 0以上の整数
const THREE_DIGITS_NUMBER_REGEXP = /^(?!.*[0-9]{4,}).*(?=^[0-9]{3}$).*/ // 3桁の数字
const MIN_THREE_DIGITS_NUMBER_REGEXP = /^([1-9]\d*|3)$/ // 3桁以上の数字
const ZIPCODE_REGEX = /^\d{3}-?\d{4}$/ // 7桁・ﾊｲﾌﾝ有り

export default {
	required: (value) =>
		(Array.isArray(value) && value.length === 0) ||
		(value !== null && value !== "") ||
		(Array.isArray(value) ? "最低一つは選択してください" : "必須項目です"),
	requiredValue: (value) => !!value || "必須項目です",
	passwordMin: (v) =>
		(v && PASSWORD_REGEX.test(v)) || "大文字・小文字の英数字8を含む8文字以上で入力してください",
	changePassword: (v) =>
		!v || PASSWORD_REGEX.test(v) || "大文字・小文字の英数字8を含む8文字以上で入力してください",
	emailFormat: (v) =>
		v == null || v == "" || EMAIL_REGEX.test(v) || "メールアドレスの正しい形式で入力してください",
	kanaFormat: (v) => (v && KANA_REGEX.test(v)) || "全角カタカナで入力してください",
	floatWithNegative: (v) =>
		v == null ||
		v == "" ||
		FLOAT_REGEX_WITH_NEGATIVE.test(v) ||
		"半角数値(小数点可)で入力してください",
	float: (v) =>
		v == null || v == "" || FLOAT_REGEX.test(v) || "0以上の数値(小数点可)で入力してください",
	integerWithNegative: (v) =>
		v == null || v == "" || INTEGER_REGEX_WITH_NEGATIVE.test(v) || "半角整数で入力してください",
	integer: (v) =>
		v == null || v == "" || ZERO_OR_MORE_REGEX.test(v) || "半角正数で入力してください",
	moreThanThree: (v) =>
		v == null || v == "" || MIN_THREE_DIGITS_NUMBER_REGEXP.test(v) || "３桁以上で入力してください",
	booleanWithBlank: (v) => v == true || v == false || v == "" || "必須項目です",
	employeeNumberFormat: (v) =>
		v == null ||
		v == "" ||
		(v && THREE_DIGITS_NUMBER_REGEXP.test(v)) ||
		"社員番号は３桁の数字で入力してください",
	number: (v) => !v || (!isNaN(v) && Number(v) >= 0) || "半角数字で入力してください",
	zipcode: (v) => !v || ZIPCODE_REGEX.test(v) || "郵便番号の正しい形式で入力してください",
	moreThanZero: (v) => !v || v > 0 || "0より大きい数値を入力してください",
}
